/**
 * Classify ImageData into a row-major binary mask (0 = background, 1 = foreground).
 * Default: near-white pixels are background; dark/colored areas are foreground.
 */

/**
 * @param {ImageData} imageData
 * @param {object} [options]
 * @param {number} [options.threshold=250] - max(R,G,B) >= threshold counts as background when not invert
 * @param {boolean} [options.invert=false] - swap foreground/background rule
 * @param {number} [options.alphaCutoff=8] - alpha below this → background
 * @returns {{ mask: Uint8Array, width: number, height: number }}
 */
export function binaryMaskFromImageData(imageData, options = {}) {
  const threshold = options.threshold ?? 250;
  const invert = options.invert ?? false;
  const alphaCutoff = options.alphaCutoff ?? 8;
  const { width: w, height: h, data } = imageData;
  const mask = new Uint8Array(w * h);

  for (let i = 0, p = 0; p < data.length; p += 4, i += 1) {
    const a = data[p + 3];
    if (a < alphaCutoff) {
      mask[i] = 0;
      continue;
    }
    const r = data[p];
    const g = data[p + 1];
    const b = data[p + 2];
    const mx = Math.max(r, g, b);
    const isBackground = mx >= threshold;
    const fg = invert ? isBackground : !isBackground;
    mask[i] = fg ? 1 : 0;
  }

  return { mask, width: w, height: h };
}
